exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h5[data-v-6ce71f66]{font-size:1.5rem;color:#333;margin-bottom:15px;font-weight:600;border-bottom:2px solid #2d5c88;padding-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ce71f66","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ims/ClientAdvanceSearch.vue
// module id = 190
// module chunks = 0